const SERIES_CHART_CONFIGS = [
  { name: "negative-plot", fill: "#FCA5A5", dataKey: "Negative" },
  { name: "positive-plot", fill: "#6EE7B7", dataKey: "Positive" },
];

export { SERIES_CHART_CONFIGS };
